import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import BackToTop from '../../components/BackToTop/BackToTop';
import FlipCard from '../../components/FlipCard/FlipCard';
import './Brands.css';

const Brands = () => {
  useScrollAnimation();

  const footwearBrands = [
    {
      frontImage: "/logos/khazanay_logo.jpg",
      frontTitle: "Khazanay",
      frontDescription: "Pakistan's leading online footwear portal",
      backTitle: "Khazanay",
      backDescription: "Shop Pre-Used, Brand New, Factory Leftover and Preloved 100% Authentic & Branded shoes online in Pakistan. Top international brands imported from the USA.",
      link: "https://www.khazanay.pk/",
      linkText: "Explore Brand",
      stats: ["100% Authentic", "International Brands", "Trusted Quality"]
    },
    {
      frontImage: "/logos/fadano_logo.jpg",
      frontTitle: "Fadano",
      frontDescription: "Everywear Style that fits anywhere.",
      backTitle: "Fadano",
      backDescription: "Fadano was born from a desire to challenge the ordinary and create footwear that serves the bold and ambitious. we honor it by reimagining it for the modern age.",
      link: "https://fadano.com/",
      linkText: "Explore Brand",
      stats: ["Modern Design", "Premium Comfort", "Timeless Elegance"]
    },
    {
      frontImage: "/logos/birdsoles_logo.jpg",
      frontTitle: "Birdsoles",
      frontDescription: "For comfortable footware designs",
      backTitle: "Birdsoles",
      backDescription: "Explore Birdsoles for sustainable, comfortable footwear designed to fit your lifestyle. Walk smarter with eco-conscious, stylish and Branded shoes.",
      link: "https://birdsoles.com/",
      linkText: "Explore Brand",
      stats: ["Eco-Conscious", "Comfort Focused", "Sustainable"]
    }
  ];

  const fmcgBrands = [
    {
      frontImage: "/logos/Sailor Gold Tea.jpg",
      frontTitle: "Sailor Gold Tea",
      frontDescription: "Dedicated to delivering premium taste to everyone.",
      backTitle: "Sailor Gold Tea",
      backDescription: "Premium quality tea that brings exceptional flavor and aroma to every cup. Carefully selected leaves for the perfect brewing experience.",
      link: "#",
      linkText: "Explore Brand",
      stats: ["Premium Quality", "Exceptional Flavor", "Carefully Selected"]
    },
    {
      frontImage: "/logos/Ronmers Coffee.jpg",
      frontTitle: "Ronmers Coffee",
      frontDescription: "High-quality Coffee, With premium taste",
      backTitle: "Ronmers Coffee",
      backDescription: "Expertly roasted coffee beans delivering rich flavor and perfect aroma. Experience the finest coffee crafted for true coffee enthusiasts.",
      link: "#",
      linkText: "Explore Brand",
      stats: ["Expertly Roasted", "Rich Flavor", "Premium Taste"]
    }
  ];

  return (
    <div className="brands-page">
      {/* Hero Section */}
      <section className="brands-hero">
        <div className="hero-background">
          <video className="hero-video" autoPlay muted loop playsInline>
            <source src="/video/video.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">E-Commerce & Brands</h1>
            <p className="hero-subtitle">
              Redefining Retail Excellence Through Premium Footwear and FMCG Brands
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">3</span>
                <span className="stat-label">Footwear Brands</span>
              </div>
              <div className="stat">
                <span className="stat-number">2</span>
                <span className="stat-label">FMCG Brands</span>
              </div>
              <div className="stat">
                <span className="stat-number">10,000+</span>
                <span className="stat-label">Happy Customers</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Redefining Retail in Pakistan</h2>
              <p>
                <strong>Khazanay, Fadano, & Birdsoles</strong> together redefine footwear in Pakistan, offering everything from premium pre-loved 
                and authentic international shoes to sophisticated dress footwear and lightweight everyday comfort styles.
              </p>
              <p>
                Khazanay brings trusted quality with curated imports, Fadano delivers timeless elegance blended with modern comfort, 
                and Birdsoles adds vibrant, ultra-comfortable designs for daily wear—ensuring every step is stylish, reliable, and uniquely you.
              </p>
            </div>
            <div className="brands-highlights">
              <h3>Our Promise</h3>
              <div className="highlights-grid">
                <div className="highlight-card">
                  <div className="highlight-icon">👟</div>
                  <h4>Premium Footwear</h4>
                  <p>Curated collection of authentic international brands</p>
                </div>
                <div className="highlight-card">
                  <div className="highlight-icon">⭐</div>
                  <h4>Quality Assured</h4>
                  <p>100% authentic products with quality guarantee</p>
                </div>
                <div className="highlight-card">
                  <div className="highlight-icon">🚚</div>
                  <h4>Nationwide Delivery</h4>
                  <p>Fast and reliable shipping across Pakistan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footwear Brands Section */}
      <section className="footwear-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Footwear Brands</h2>
            <p>Premium footwear brands catering to every style and occasion</p>
          </div>
          
          <div className="flip-cards-grid">
            {footwearBrands.map((brand, index) => (
              <FlipCard
                key={index}
                frontImage={brand.frontImage}
                frontTitle={brand.frontTitle}
                frontDescription={brand.frontDescription}
                backTitle={brand.backTitle}
                backDescription={brand.backDescription}
                link={brand.link}
                linkText={brand.linkText}
                stats={brand.stats}
              />
            ))}
          </div>
        </div>
      </section>

      {/* FMCG Brands Section */}
      <section className="fmcg-section">
        <div className="container">
          <div className="section-header">
            <h2>Trimline FMCG Brands</h2>
            <p>Premium quality tea and coffee for everyday indulgence</p>
          </div>

          <div className="fmcg-intro">
            <p>
              <strong>RONMERS & SAILOR GOLD</strong> - Two proud brands of 
              Trimline Group, dedicated to delivering premium taste to 
              everyone. Specializing in high-quality Tea & Coffee, we aim to 
              redefine indulgence with an accessible pricing model.
            </p>
          </div>
          
          <div className="flip-cards-grid fmcg-grid">
            {fmcgBrands.map((brand, index) => (
              <FlipCard
                key={index}
                frontImage={brand.frontImage}
                frontTitle={brand.frontTitle}
                frontDescription={brand.frontDescription}
                backTitle={brand.backTitle}
                backDescription={brand.backDescription}
                link={brand.link}
                linkText={brand.linkText}
                stats={brand.stats}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="brands-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Experience Premium Brands</h2>
            <p>Discover our curated collection of footwear and FMCG brands designed to elevate your lifestyle.</p>
            <div className="cta-buttons">
              <a href="https://www.khazanay.pk/" className="btn btn-primary">Shop Now</a>
              <a href="/contact" className="btn btn-secondary">Contact Us</a>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default Brands;